import { Box, SimpleGrid } from "@chakra-ui/react";
import { useRef, useMemo } from "react";
import ScoreCard from '@/components/Molecules/ScoreCard';
import GroupedBarChart from '@/components/Organisms/GroupedBarChart';
import { BookmarkIcon } from '@/assets/icons';
import FaceliftText from "@/components/Atoms/FaceliftText";
import { useGetScoreCards, useGetChartData } from '@/hooks/service-hooks/appCrashReport';
import { getDateRange } from '@/utils/dateUtils';
import { DateRange } from '@/components/Molecules/FaceliftDatePicker';

const AppCrashReportOverview = () => {
  // --- Refs for Driver.js tour ---
  const [scorecardsRef, productsChartRef] = [useRef<HTMLDivElement | null>(null), useRef<HTMLDivElement | null>(null)];

  // --- Calculate year_to_date range ---
  const yearToDateRange = useMemo(() => {
    const emptyDateRange: DateRange = { startDate: '', endDate: '' };
    return getDateRange('last_12_months', emptyDateRange, 'dateISO');
  }, []);

  // --- Fetch score cards data from API ---
  const { data: scoreCardData = [], isFetching: isScoreCardsLoading } = useGetScoreCards();

  // --- Fetch chart data from API with year_to_date range ---
  const { data: bvChartData = [], isFetching: isChartDataLoading } = useGetChartData(
    yearToDateRange.startDate,
    yearToDateRange.endDate
  );

  return (
    <Box>
      <FaceliftText fontWeight={600} fontSize="x-large" px={{ base: 4, md: 8 }} py={4}>
        Overview
      </FaceliftText>

      <Box
        mb={8}
        ml={{ base: 0, md: 7 }}
        mr={{ base: 0, md: 7 }}
        ref={scorecardsRef}
      >
        <SimpleGrid
          columns={{ base: 1, md: 3, lg: 6 }}
          gap={{ base: 2, md: 2 }}
        >
          {scoreCardData.map((card) => (
            <ScoreCard
              key={card.title}
              title={card.title}
              value={card.value}
              subtitle={'This Month'}
              icon={<BookmarkIcon />}
              iconSize="42px"
              isLoading={isScoreCardsLoading}
            />
          ))}
        </SimpleGrid>
      </Box>

      <Box
        ml={{ base: 0, md: 7 }}
        mr={{ base: 0, md: 7 }}
        ref={productsChartRef}
      >
        <GroupedBarChart
          title={'App Crashes (Monthly)'}
          data={bvChartData}
          isLoading={isChartDataLoading}
          height={400}
        />
      </Box>
    </Box>
  );
};


// const AppCrashReportOverview = () => <></>
export default AppCrashReportOverview;